

export const activeMenuItemSelector = state => state.app.menu.activeMenuItem;